import convertTo24HourFormat from "./convertTo24HourFormat"

const formatOpeningHours = (openingHours) =>
    openingHours.reduce((formattedHours, [day, hours]) => {
        if (hours.isOpen)
            formattedHours.push(
                `${day.slice(0, 2)} ${convertTo24HourFormat(
                    hours.open
                )}-${convertTo24HourFormat(hours.close)}`
            )

        return formattedHours
    }, [])

const generateStoreSchema = (
    {
        storeId,
        storeState,
        storeCity,
        storeAddress,
        storePostCode,
        storeCountry,
        organicPhone,
        storeLat,
        storeLong,
        hours,
    },
    stateAbbreviation
) => {
    return {
        "@context": "https://schema.org",
        "@type": "AutoBodyShop",
        name: "Maaco Auto Body Shop & Painting",
        url: `https://www.maaco.com/locations/${stateAbbreviation.toLowerCase()}/${storeCity.toLowerCase()}-${storeId}/`,

        telephone: organicPhone,
        branchCode: storeId,
        address: {
            "@type": "PostalAddress",
            streetAddress: storeAddress,
            addressLocality: storeState,
            addressRegion: storeState,
            postalCode: storePostCode,
            addressCountry: storeCountry,
        },

        geo: {
            "@type": "GeoCoordinates",
            latitude: storeLat,
            longitude: storeLong,
        },
        openingHours: formatOpeningHours(Object.entries(hours)),
    }
}

export default generateStoreSchema
